<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="FixedAsset"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <DIV
    class="page--v2 d-flex flex-column"
    v-if="loaded"
  >
    <MaterialTabs>
      <ItpBox
        alignItems="center"
        class="mr-3"
        slot="tabs-start"
      >
        <b-breadcrumb
          class="m-0 bg-white"
        >
          <b-breadcrumb-item
            :text="'Fixed Assets'|gettext"
            :to="b_2285343489561581_to"
          >
          </b-breadcrumb-item>
          <b-breadcrumb-item
            :text="item.snapshot('name')"
            active
          >
          </b-breadcrumb-item>
        </b-breadcrumb>
        <ItpButton
          variant="default"
          icon="fa-sync-alt"
          :text="'Reload'|gettext"
          :spinning="actions.reload.isRunning"
          class="px-3"
          @click.prevent.stop="evh_2095089031469157_clickPreventStop($event, {})"
        >
        </ItpButton>
        <BtnDeleteResource
          :resource="item"
          no-text
          :dialogHeader="messages.delete"
          class="mr-2"
          @success="evh_9004123373732307_success($event, {})"
        >
        </BtnDeleteResource>
      </ItpBox>
      <b-tab
        :title="'General'|gettext"
        class="container float-left"
      >
        <ItpRow>
          <ItpCol
            w="6"
          >
            <UcFixedAssetGeneral
              :fixedAsset="item"
              :reload="lastLoaded"
              class="pb-4"
              @reload="evh_2679161326024595_reload($event, {})"
            >
            </UcFixedAssetGeneral>
          </ItpCol>
          <ItpCol
            w="6"
          >
            <UcFixedAssetWasteBin
              :fixedAsset="item"
              :reload="lastLoaded"
              class="pb-4"
              v-if="item && item.asset_type === 'waste_bin'"
              @reload="evh_2789477278097085_reload($event, {})"
            >
            </UcFixedAssetWasteBin>
            <UcCommentsList
              :parent="item"
              :reload="lastLoaded"
              class="pb-4"
            >
            </UcCommentsList>
            <UcAttachmentsList
              :parent="item"
              :reload="lastLoaded"
              class="pb-4"
            >
            </UcAttachmentsList>
            <UcFixedAssetWorkItemsPanel
              :oid="item.id"
              :reload="lastLoaded"
              class="pb-4"
              @reload="evh_8856043737157701_reload($event, {})"
            >
            </UcFixedAssetWorkItemsPanel>
          </ItpCol>
        </ItpRow>
      </b-tab>
    </MaterialTabs>
  </DIV>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "fixedAsset",
    path: "/fixed-assets/:id",
    component: "FixedAsset",
    params: [{
      name: "id",
      prop: "fixedAssetId",
    }
      ,
    ]

  }
)

@Component()
export default class FixedAsset extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
  })
  fixedAssetId!: string;

  @Watch('fixedAssetId')
  onFixed_asset_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("fixedAssetId")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  item!: any;

  async $$load_item() {
    return this.$fn.fetch('read_fixed_asset', { asResource: true, parameters: { id: this.fixedAssetId } })
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  messages!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2285343489561581_to!: any;
  dataMembers = ['item', 'formId', 'messages', 'ux', 'b_7315092382398562_modalBindings', 'b_2285343489561581_to'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        item: null,
        formId: null,
        messages: {
          delete: this.$fn.pgettext("FixedAsset|Header", "Delete fixed asset"),
        }
        ,
        ux: {
          initialLoadSpinner: true,
        }
        ,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_2285343489561581_to: {
          name: "app.fixedAssets",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: [this.item.snapshot('name')
          ,
        this.$fn.gettext("Fixed Asset")
          ,
        ]
        ,
        icon: this.$config.fixedAsset.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_1924_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_1924, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2095089031469157_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2095089031469157_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async evh_9004123373732307_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_9004123373732307_success.executeFromDOM(this, event, scope);
  }

  async evh_2679161326024595_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2679161326024595_reload.executeFromDOM(this, event, scope);
  }

  async evh_2789477278097085_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2789477278097085_reload.executeFromDOM(this, event, scope);
  }

  async evh_8856043737157701_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8856043737157701_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_1924: actions.CloseModalAction;
    evh_7315092382398562_close_1923: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2095089031469157_reloadComponentData_1926: actions.ReloadComponentDataAction;
    evh_2095089031469157_clickPreventStop_1925: actions.EventHandlerImpl;
    evh_2095089031469157_clickPreventStop: actions.EventHandlerGroup;
    act_9004123373732307_closeComponent_1928: actions.CloseComponentAction;
    evh_9004123373732307_success_1927: actions.EventHandlerImpl;
    evh_9004123373732307_success: actions.EventHandlerGroup;
    act_2679161326024595_reloadComponentData_1930: actions.ReloadComponentDataAction;
    evh_2679161326024595_reload_1929: actions.EventHandlerImpl;
    evh_2679161326024595_reload: actions.EventHandlerGroup;
    act_2789477278097085_reloadComponentData_1932: actions.ReloadComponentDataAction;
    evh_2789477278097085_reload_1931: actions.EventHandlerImpl;
    evh_2789477278097085_reload: actions.EventHandlerGroup;
    act_8856043737157701_reloadComponentData_1934: actions.ReloadComponentDataAction;
    evh_8856043737157701_reload_1933: actions.EventHandlerImpl;
    evh_8856043737157701_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_1924 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_1924_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_1923 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_1924,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_1923],
      }
    );
    const act_2095089031469157_reloadComponentData_1926 = new actions.ReloadComponentDataAction(
      {
        displayName: "reload",
        events: [],
      }
    );
    const evh_2095089031469157_clickPreventStop_1925 = new actions.EventHandlerImpl(
      {
        action: act_2095089031469157_reloadComponentData_1926,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_2095089031469157_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2095089031469157_clickPreventStop_1925],
      }
    );
    const act_9004123373732307_closeComponent_1928 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_9004123373732307_success_1927 = new actions.EventHandlerImpl(
      {
        action: act_9004123373732307_closeComponent_1928,
        event: "success",
        displayName: "closeComponent",
      }
    );
    const evh_9004123373732307_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_9004123373732307_success_1927],
      }
    );
    const act_2679161326024595_reloadComponentData_1930 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_2679161326024595_reload_1929 = new actions.EventHandlerImpl(
      {
        action: act_2679161326024595_reloadComponentData_1930,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_2679161326024595_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_2679161326024595_reload_1929],
      }
    );
    const act_2789477278097085_reloadComponentData_1932 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_2789477278097085_reload_1931 = new actions.EventHandlerImpl(
      {
        action: act_2789477278097085_reloadComponentData_1932,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_2789477278097085_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_2789477278097085_reload_1931],
      }
    );
    const act_8856043737157701_reloadComponentData_1934 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_8856043737157701_reload_1933 = new actions.EventHandlerImpl(
      {
        action: act_8856043737157701_reloadComponentData_1934,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_8856043737157701_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_8856043737157701_reload_1933],
      }
    );
    return {
      act_7315092382398562_closeModal_1924,
      evh_7315092382398562_close_1923,
      evh_7315092382398562_close,
      act_2095089031469157_reloadComponentData_1926,
      evh_2095089031469157_clickPreventStop_1925,
      evh_2095089031469157_clickPreventStop,
      act_9004123373732307_closeComponent_1928,
      evh_9004123373732307_success_1927,
      evh_9004123373732307_success,
      act_2679161326024595_reloadComponentData_1930,
      evh_2679161326024595_reload_1929,
      evh_2679161326024595_reload,
      act_2789477278097085_reloadComponentData_1932,
      evh_2789477278097085_reload_1931,
      evh_2789477278097085_reload,
      act_8856043737157701_reloadComponentData_1934,
      evh_8856043737157701_reload_1933,
      evh_8856043737157701_reload,
      reload: act_2095089031469157_reloadComponentData_1926,
    }
  }
}

Vue.component("FixedAsset", FixedAsset);

</script>